export const pinkHover = "#A0325E";
export const pinkHoverLight = "#b85e82";
export const modalBackground = "#1B1B1B";
export const logoBackground = "#171717";
